<template>
  <el-form ref="form_youtube" :model="form_youtube" label-width="0px" @submit.native.prevent>
    <div class="side-search-form-box">
      <div class="side-search-form-title">チャンネル名/キーワード検索</div>
      <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
        <div class="side-search-form-radio" v-show="activate > 10">
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form_youtube.radio" :label="1" @change="yResetKeyword()">
            チャンネル名
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form_youtube.radio" :label="2" @change="yResetKeyword()">
            キーワード
            <el-tooltip placement="top" content="名前、プロフィール、投稿内容に含まれるキーワードで検索します。">
              <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px"/>
            </el-tooltip>
          </el-radio>
        </div>
        <div class="side-search-form-radio" v-show="activate < 10">
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form_youtube.radio" :label="1">チャンネル名</el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" v-model="form_youtube.radio" :label="2" disabled>キーワード
          </el-radio>
        </div>
        <sidemenuSuggestInfluencer 
          v-show="form_youtube.radio == 1" 
          :name.sync="form_youtube.channel_name"
          :sns_type="'youtube'" 
          @resultCount="resultCount()" 
          @nameSearch="nameSearch()"
        />
        <sidemenuSuggestKeyword 
          v-show="form_youtube.radio==2" 
          :keyword.sync="form_youtube.keyword" 
          :sns_type="'youtube'" 
          :exclude_keyword.sync="form_youtube.exclude_keyword" 
          @resultCount="resultCount()" 
          @search="ySearch()"
        />
      </div>
    </div>

    <div class="side-search-form-box">
      <div class="side-search-form-title">他SNS登録</div>
      <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
        <el-radio-group v-model="form_youtube.other_sns_type" size="mini" style="margin: 12px 0 0;"
                        @change="resultCount()">
          <el-radio :class="dark_mode ? 'dark' : ''" label="">
            -
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" label="instagram">
            <font-awesome-icon :icon="['fab', 'instagram']" style="margin-left:4px; font-size:16px"/>
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" label="tiktok">
            <font-awesome-icon :icon="['fab', 'tiktok']" style="margin-left:4px; font-size:16px"/>
          </el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" label="twitter">
            <svg width="13" height="13" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
                  fill="currentColor"/>
            </svg>
          </el-radio>
        </el-radio-group>
      </div>
    </div>

    <div class="side-search-form-box">
      <div class="side-search-form-title">性別</div>
      <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'">
        <div class="side-search-form-radio youtube" style="margin-bottom:0px">
          <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_youtube.gender_female" @change="resultCount()">
            女性
          </el-checkbox>
          <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_youtube.gender_male" @change="resultCount()">
            男性
          </el-checkbox>
          <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_youtube.gender_group" @change="resultCount()">
            グループ
          </el-checkbox>
          <el-checkbox :class="dark_mode ? 'dark' : ''" v-model="form_youtube.gender_other" @change="resultCount()"
                       class="bottom">
            その他
            <el-tooltip placement="top" content="その他: 番組、漫画、キャラクター、動物、ブランド・企業公式チャンネルなど">
              <font-awesome-icon icon="question-circle" style="margin-left:3px; font-size:12px"/>
            </el-tooltip>
          </el-checkbox>
          <el-checkbox :class="dark_mode ? 'dark' : ''" v-if="activate == 20 && admin_mode"
                       v-model="form_youtube.gender_null" @change="resultCount()" class="bottom"></el-checkbox>
        </div>
      </div>
    </div>
    <div class="side-search-form-title">チャンネル登録者数</div>
    <el-form-item label class="slider">
      <el-slider :class="dark_mode ? 'dark' : ''" v-model="form_youtube.subscriber" @change="resultCount()" :step="5000"
                 name="follower" :marks="follower_marks" range :max="500000"></el-slider>
    </el-form-item>
    <div class="side-search-form-title">視聴率中央値(長尺)</div>
    <el-form-item label class="slider">
      <el-slider
          :class="dark_mode ? 'dark' : ''"
          v-model="form_youtube.median_viewRate_long_3month"
          @change="resultCount()"
          :step="10"
          name="median_viewRate_long_3month"
          :marks="viewRate_marks"
          range
          :max="100"
      ></el-slider>
    </el-form-item>
    <div class="side-search-form-title">視聴率中央値(ｼｮｰﾄ動画)</div>
    <el-form-item label class="slider">
      <el-slider
          :class="dark_mode ? 'dark' : ''"
          v-model="form_youtube.median_viewRate_short_3month"
          @change="resultCount()"
          :step="10"
          name="median_viewRate_short_3month"
          :marks="viewRate_marks"
          range
          :max="100"
      ></el-slider>
    </el-form-item>
    <!-- 視聴回数（長尺） -->
    <div class="side-search-form-title">視聴回数中央値(長尺)</div>
    <el-form-item label class="slider" style="margin-bottom:10px">
      <el-slider
          class="sidemenu-load"
          :class="dark_mode ? 'dark' : ''"
          v-model="form_youtube.median_viewCount_long_3month"
          name="median_viewCount_long_3month"
          :marks="median_viewCount_long_3month_marks"
          @change="resultCount()"
          :step="1000"
          range
          :max="500000"
      ></el-slider>
    </el-form-item>
    <!-- 視聴回数（ｼｮｰﾄ動画） -->
    <div class="side-search-form-title">視聴回数中央値(ｼｮｰﾄ動画)</div>
    <el-form-item label class="slider" style="margin-bottom:10px">
      <el-slider
          class="sidemenu-load"
          :class="dark_mode ? 'dark' : ''"
          v-model="form_youtube.median_viewCount_short_3month"
          name="median_viewCount_short_3month"
          :marks="median_viewCount_short_3month_marks"
          @change="resultCount()"
          :step="1000"
          range
          :max="500000"
      ></el-slider>
    </el-form-item>

    <div class="side-search-form-title">EGR</div>
    <el-form-item label class="slider">
      <el-slider
          :class="dark_mode ? 'dark' : ''"
          v-model="form_youtube.average_engagement_rate"
          @change="resultCount()"
          :step="0.5"
          name="average_engagement_rate"
          :marks="average_engagement_rate_marks"
          range
          :max="10"
      ></el-slider>
    </el-form-item>
    <div class="side-search-form-title">チャンネル登録者女性比率</div>
    <el-form-item label>
      <el-slider
          class="sidemenu-load"
          :class="dark_mode ? 'dark' : ''"
          v-model="form_youtube.female_ratio"
          @change="resultCount()"
          :step="5"
          name="gender"
          :marks="female_ratio_marks"
          range
          :max="100"
      ></el-slider>
    </el-form-item>
    <!-- PR率（長尺） -->
    <div class="side-search-form-title">PR率(長尺)</div>
    <el-form-item label class="slider">
      <el-slider
          class="sidemenu-load"
          :class="dark_mode ? 'dark' : ''"
          v-model="form_youtube.prRate_long_3month"
          @change="resultCount()"
          :step="1"
          name="prRate_long_3month"
          :marks="prRate_long_3month_marks"
          range
          :min="0"
          :max="100"
      ></el-slider>
    </el-form-item>
    <!-- PR率（ｼｮｰﾄ動画） -->
    <div class="side-search-form-title">PR率(ｼｮｰﾄ動画)</div>
    <el-form-item label class="slider">
      <el-slider
          class="sidemenu-load"
          :class="dark_mode ? 'dark' : ''"
          v-model="form_youtube.prRate_short_3month"
          @change="resultCount()"
          :step="1"
          name="prRate_short_3month"
          :marks="prRate_short_3month_marks"
          range
          :min="0"
          :max="100"
      ></el-slider>
    </el-form-item>
    <div class="side-search-form-title">
      <span class="pointer" @click="showDetailOption()"
      >詳細オプション
        <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left: 5px;"/>
      </span>
    </div>
    <div :class="dark_mode ? 'side-search-form-content dark' : 'side-search-form-content'" style="margin-bottom:10px"
         v-show="detail_option">
      <div class="side-search-form-title" style="color: #aaa; margin-top:5px">フォロワーの年齢層を指定</div>
      <el-form-item>
        <el-select
            clearable
            class="sidemenu-input"
            :class="dark_mode ? 'dark' : ''"
            v-model="form_youtube.main_audience"
            @change="resultCount()"
            style="margin-left: 0px;"
            placeholder="フォロワーの年齢層"
            size="mini"
        >
          <el-option label="13-17" value="13_17"></el-option>
          <el-option label="18-24" value="18_24"></el-option>
          <el-option label="25-34" value="25_34"></el-option>
          <el-option label="35-44" value="35_44"></el-option>
          <el-option label="45-54" value="45_54"></el-option>
          <el-option label="55-64" value="55_64"></el-option>
        </el-select>
        <el-slider
            v-if="form_youtube.main_audience && form_youtube.main_audience.match(/\_/)"
            style="margin-top:5px"
            class="sidemenu-load"
            :class="dark_mode ? 'dark' : ''"
            v-model="form_youtube.main_audience_percent"
            @change="resultCount()"
            :step="5"
            name="gender"
            :marks="female_ratio_marks"
            range
            :max="100"
        ></el-slider>
      </el-form-item>
      <div class="side-search-form-title" style="color: #aaa;">リストに含まれるインフルエンサーを除外</div>
      <el-form-item>
        <el-cascader
            v-model="form_youtube.exclude_list"
            :options="sidemenu_option.mylist_youtube"
            :show-all-levels="false"
            :props="{ multiple: true }"
            placeholder="除外するリストを選択"
            collapse-tags
            clearable
            filterable
            @change="resultCount()"
            :class="dark_mode ? 'dark' : ''"
            size="mini"
        ></el-cascader>
      </el-form-item>
      <div class="side-search-form-title" style="color: #aaa;">お気に入りの有無</div>
      <el-form-item>
        <el-select clearable :class="dark_mode ? 'dark' : ''" v-model="form_youtube.exclude_favorite"
                   @change="resultCount()" style="margin-left: 0px;" placeholder="お気に入りの有無" size="mini">
          <el-option label="お気に入りのみを表示" value="only"></el-option>
          <el-option label="お気に入りを除外して表示" value="exclude"></el-option>
        </el-select>
      </el-form-item>
      <div class="side-search-form-title" style="color: #aaa;">カスタマイズタグ</div>
      <div class="side-search-form-radio">
        <el-radio-group v-model="form_youtube.tags_search_type" size="mini" @change="resultCount()">
          <el-radio :class="dark_mode ? 'dark' : ''" :label="1">AND検索</el-radio>
          <el-radio :class="dark_mode ? 'dark' : ''" :label="2">OR検索</el-radio>
        </el-radio-group>
      </div>
      <el-form-item>
        <el-cascader
            v-model="form_youtube.tags"
            :options="sidemenu_option.tag_list"
            :show-all-levels="false"
            :props="{ multiple: true }"
            placeholder="カスタマイズタグを選択"
            collapse-tags
            clearable
            filterable
            @change="resultCount()"
            :class="dark_mode ? 'dark' : ''"
            size="mini"
        ></el-cascader>
      </el-form-item>
    </div>

    <div class="side-search-form-button" :class="dark_mode ? 'dark' : ''">
      <el-button size="small" @click="resetParams()" style="margin-right:10px;" :type="dark_mode ? 'info' : 'default'"
                 :class="dark_mode ? 'dark' : ''">リセット
      </el-button>
      <div style="display:flex; flex:1">
        <el-button size="small" native-type="submit" type="primary" :class="dark_mode ? 'dark' : ''" @click="ySearch()"
                   style="width:100%">
          <div class="flex-row">
            検索
            <div class="loader--mini" v-if="result_loading"></div>
          </div>
        </el-button>
      </div>
    </div>
  </el-form>
</template>

<script>
const root = process.env.VUE_APP_API;
const yResultCountAPI = root + "/api/search/result_count_youtube";
import sidemenuSuggestInfluencer from "./sidemenu_suggest_influencer";
import sidemenuSuggestKeyword from "./sidemenu_suggest_keyword";
import { runCampaignGate } from '@/utils/campaignGate';

export default {
  name: "sidemenuYouTube",
  components: {
    sidemenuSuggestInfluencer,
    sidemenuSuggestKeyword,
  },
  data() {
    return {
      result_count: "",
      follower_marks: {
        500000: "500K+",
      },
      female_ratio_marks: {
        100: "100%",
      },
      average_engagement_rate_marks: {
        10: "10%+",
      },
      viewRate_marks: {
        100: "100%+",
      },
      average_play_count_marks: {
        500000: "500K+",
      },
      pr_rate_marks: {
        100: "100%",
      },
      median_viewCount_long_3month_marks: { 500000: "500K+" },
      median_viewCount_short_3month_marks: { 500000: "500K+" },
      prRate_long_3month_marks: { 100: "100%" },
      prRate_short_3month_marks: { 100: "100%" },
      mylist_youtube: [],
      actionId: +new Date(),
      requestId: +new Date(),
      result_loading: false,
      next_cursor: "",
      language: "jp",
      noindex: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    dark_mode() {
      return this.$store.state.dark_mode;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    activate() {
      return this.$store.state.activate;
    },
    form_youtube() {
      return this.$store.state.form_youtube;
    },
    form_youtube_initial() {
      return this.$store.state.form_youtube_initial;
    },
    y_search() {
      return this.$store.state.y_search;
    },
    sidemenu_option() {
      return this.$store.state.sidemenu_option;
    },
    detail_option() {
      return this.$store.state.detail_option;
    },
  },
  mounted() {
  },
  created() {
  },
  methods: {
    resultCount() {
      this.noindex = false;
      this.result_loading = true;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      const form_youtube = Object.assign({}, this.form_youtube);
      form_youtube.has_recent_post_1month = !!this.$store.state.recent_post_1month;
      params.append("params", JSON.stringify(form_youtube));
      this.axios
          .post(yResultCountAPI, params, {requestId: this.requestId})
          .then((response) => {
            this.result_loading = false;
            this.result_count = response.data.result_count;
            this.noindex = response.data.noindex;
            this.$store.dispatch("form_youtube", form_youtube);
          })
          .catch(() => {
            this.result_count = 0;
          });
    },
    async ySearch() {
      var form_youtube = Object.assign({}, this.form_youtube);
      form_youtube.has_recent_post_1month = !!this.$store.state.recent_post_1month;

      // 記号は「._()@#&･/!|:~」及び全角のみ許可（チャンネル名検索時はスラッシュ・!・|・:・@・~を許容）
      var regChannelName = new RegExp(/["$%'*+,;<=>?[\]\\^`{}]/);
      // キーワード検索時はスラッシュを含む記号を不許可
      var regKeyword = new RegExp(/[!"$%'*+,/:;<=>?@[\\\]^`{|}~]/);
      // ローマ字1文字（大文字・小文字）だけの入力をNG
      var singleAlphaReg = new RegExp(/^[A-Za-z]$/);

      if (form_youtube.radio === 1) {
        // チャンネル名検索
        if (
          regChannelName.test(form_youtube.channel_name) ||
          singleAlphaReg.test(form_youtube.channel_name)
        ) {
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "検索キーワードが短すぎる、もしくは使用できない記号が含まれています",
          });
          return;
        }
      } else {
        // キーワード検索
        // channel_name は通常ラジオ切り替え時にリセットされるが、
        // 想定外の値が残った場合でも禁止記号を弾くため防御的に同じバリデーションをかける
        if (
          regChannelName.test(form_youtube.channel_name) ||
          regKeyword.test(form_youtube.keyword) ||
          regKeyword.test(form_youtube.exclude_keyword) ||
          singleAlphaReg.test(form_youtube.channel_name) ||
          singleAlphaReg.test(form_youtube.keyword) ||
          singleAlphaReg.test(form_youtube.exclude_keyword)
        ) {
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "検索キーワードが短すぎる、もしくは使用できない記号が含まれています",
          });
          return;
        }
      }

      // キャンペーンモーダルを表示（閉じたら続行）
      try {
        await runCampaignGate('partner_introduce');
      } catch (e) {/* no-op: モーダル取得に失敗しても検索は続行 */}
      
      this.$store.dispatch("y_search", form_youtube);
      this.$store.dispatch("form_youtube", form_youtube);
      this.$router.push({
        name: "youtuber",
        query: {actionId: (this.actionId += 1)},
      });
    },
    nameSearch() {
      const channel_name = this.form_youtube.channel_name;
      var form_youtube = Object.assign({}, this.form_youtube_initial);
      form_youtube.channel_name = channel_name;
      this.$store.dispatch("form_youtube", form_youtube);
      this.resultCount();
      this.ySearch();
    },
    resetParams() {
      this.$store.dispatch("recent_post_1month", false);
      this.$store.dispatch("form_youtube", Object.assign({}, this.form_youtube_initial)).then(() => {
        this.resultCount();
      });
    },
    yResetKeyword() {
      this.form_youtube.channel_name = "";
      this.form_youtube.keyword = "";
      this.form_youtube.exclude_keyword = "";
      this.resultCount();
    },
    showDetailOption() {
      this.$store.dispatch("showDetailOption");
    },
  },
};
</script>
